<template>
  <div v-if="isLoading" class="relative py-5">
    <BaseInnerLoading spinner-class="size-8" />
  </div>
  <ErrorText v-else-if="isError">
    Failed to load terminals
  </ErrorText>
  <ul
    v-else-if="data && data.items.length > 0"
    class="space-y-2"
  >
    <li v-for="terminal in data.items" :key="terminal.id">
      <div
        class="grid grid-cols-6 content-center gap-2 rounded-lg border border-background-fg/8 px-4 py-2 shadow-sm md:grid-cols-10"
      >
        <div
          class="col-span-6 line-clamp-1 text-left font-semibold md:col-span-4"
        >
          {{ terminal.serialNumber }}
        </div>

        <div
          class="col-span-3 flex items-center text-xs text-background-fg/70"
        >
          Last transacted
          {{
            terminal.lastTransactedAt
              ? DateFns.formatDistance(
                  terminal.lastTransactedAt,
                  new Date(),
                  {
                    addSuffix: true,
                  }
                )
              : "-"
          }}
        </div>

        <div
          class="col-span-3 flex items-center text-xs text-background-fg/70"
        >
          Last paired
          {{
            terminal.lastPaired
              ? DateFns.formatDistance(
                  terminal.lastPaired,
                  new Date(),
                  {
                    addSuffix: true,
                  }
                )
              : "-"
          }}
        </div>
      </div>
    </li>
  </ul>

  <p v-else class="text-center"
    >No terminals associated with this merchant</p
  >

  <div class="flex justify-end py-2">
    <BasePagination
      v-model:page="page"
      :page-count="pageCount"
    />
  </div>
</template>

<script setup lang="ts">
import type { ListMerchantGroupDetailTerminalsQuery } from "@/services/merchantGroup/terminals/listMerchantGroupDetailTerminals"

const props = defineProps<{
  schemaName: string
}>()

const { page, pageCount, paginationQuery } = usePagination({
  count: computed(() => data.value?.count || 0),
  limit: 10,
})

const query =
  reactiveComputed<ListMerchantGroupDetailTerminalsQuery>(
    () => ({
      schemaName: props.schemaName,
      ...paginationQuery.value,
    })
  )

const { data, isLoading, isError } =
  useMerchantGroupDetailTerminals(query)
</script>
